export const CustomForward = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M10.6666 11.3333L9.71659 10.4L12.7833 7.33334L9.71659 4.26668L10.6666 3.33334L14.6666 7.33334L10.6666 11.3333ZM1.33325 12.6667V10C1.33325 9.07779 1.65825 8.29168 2.30825 7.64168C2.95825 6.99168 3.74436 6.66668 4.66659 6.66668H8.78325L6.38325 4.26668L7.33325 3.33334L11.3333 7.33334L7.33325 11.3333L6.38325 10.4L8.78325 8.00001H4.66659C4.11103 8.00001 3.63881 8.19445 3.24992 8.58334C2.86103 8.97223 2.66659 9.44445 2.66659 10V12.6667H1.33325Z"
                fill="black"
                fillOpacity="0.5"
            />
        </svg>
    );
};
